import React from "react";
import useProductName from "brand-customization/useProductName";
import { useTranslation } from "react-i18next";
import { Panel } from "components/bootstrap";
import ForwarderSelectionList from "../ForwarderSelectionList";
const SelectNewForwarderStep = ({ eventKey, forwarders, onForwarderSelect }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Panel, { eventKey }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, null, /* @__PURE__ */ React.createElement(Panel.Toggle, { tabIndex: 0 }, t("select_new_forwarder.heading")))), /* @__PURE__ */ React.createElement(Panel.Body, { collapsible: true }, /* @__PURE__ */ React.createElement("p", null, t("select_new_forwarder.intro", { productName })), /* @__PURE__ */ React.createElement(ForwarderSelectionList, { forwarders, onForwarderSelect })));
};
export default SelectNewForwarderStep;
